<template>
  <Cascader
    clearable
    filterable
    :change-on-select="true"
    :value="localValue"
    :placeholder="placeholder"
    :data="addressList"
    :load-data="loadList"
    :disabled="disabled"
    @on-change="change"
  ></Cascader>
</template>

<script>
const getData = function (id) {
  return this.$http.get('/area/list', {
    params: {
      parentId: id,
    },
  })
}
export default {
  name: 'AddressCB',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default() {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: 3,
      validator: (value) => [1, 2, 3, 4].includes(value),
    },
  },
  data() {
    return {
      addressList: [],
      localValue: [],
      getData: getData.bind(this),
    }
  },
  watch: {
    value: {
      handler(val, old) {
        this.getRealAddr()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    loadList(item, callback) {
      if (!item || item.loading) return
      item.loading = true

      this.getData(item.value).then((res) => {
        item.children = []
        for (let address of res.data) {
          let data = {
            value: address.id,
            label: address.name,
            children: [],
          }
          if (address.level !== this.level && address.hasChild > 0) {
            data.loading = false
          }
          item.children.push(data)
        }
        item.loading = false

        if (callback) {
          callback()
        }
      })
    },
    change(value, selectedData) {
      this.$emit('on-change', value, selectedData)
      // this.$emit('input', value, selectedData)
    },
    async init() {
      let { data } = await this.getData(1)
      this.addressList = data.map((address) => ({
        value: address.id,
        label: address.name,
        loading: false,
        children: [],
      }))
      // await this.getRealAddr()
    },
    async getRealAddr() {
      if (!this.addressList.length) await this.init()
      // 去除undedined
      let localValue = this.value.filter(Boolean).map(Number)
      this.localValue = localValue
      let index = 0
      let item = null

      let callback = () => {
        index++
        if (index < localValue.length - 1) {
          item = item.children.find((v) => v.value === localValue[index])
          this.loadList(item, callback)
        }
      }

      if (index < localValue.length) {
        item = this.addressList.find((v) => v.value === localValue[index])
        this.loadList(item, callback)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/AddressCB.vue